// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teleDriversSection {
  height: calc(100vh - 556px);
  overflow-x: hidden;
  direction: rtl;
}
.teleDriversSection .teleDriverCount {
  direction: ltr;
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  font-family: "Poppins";
  color: rgba(255, 255, 255, 0.7);
  margin-left: 13.84px;
}
.teleDriversSection .teleDriver {
  height: 51px;
  background: #2B3045;
  margin-top: 16px;
  border-radius: 10px;
  padding: 16px 8px 16px 8px;
  direction: ltr;
  display: flex;
  align-items: center;
  position: relative;
  gap: 12px;
  margin-left: 13.84px;
  min-width: 425px;
  justify-content: space-between;
}
.teleDriversSection .teleDriver .teleDriverOption {
  position: relative;
  min-width: 24px;
}
.teleDriversSection .teleDriver .teleDriverOption:hover {
  background: none;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverName {
  font-size: 16px;
  line-height: 16px;
  font-family: "Poppins";
  font-weight: 500;
  margin-bottom: 5px;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverDetails {
  font-size: 14px;
  line-height: 22px;
  font-family: "Poppins";
  font-weight: 400;
  display: flex;
  gap: 10px;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverDetails .wrapper {
  display: flex;
  align-items: center;
  position: relative;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverDetails span {
  border-radius: 50%;
  height: 12px;
  width: 12px;
  display: block;
  float: left;
  margin-right: 5px;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverDetails .green {
  background: #58DA78;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverDetails .orange {
  background: #FF8B1E;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverDetails .purple {
  background: #797E98;
}
.teleDriversSection .teleDriver .teleDriverSec .teleDriverDetails .MuiBox-root:after {
  content: "";
  margin: 0 4px;
  border-left: 2px solid rgba(255, 255, 255, 0.2);
  position: absolute;
  bottom: 5px;
  right: -10px;
  height: 12.78px;
}
.teleDriversSection .teleDriver .teleDriverImage img {
  width: 51px;
  height: 51px;
  border-radius: 50%;
}

.teleDriverDetails .MuiBox-root:last-child:after {
  margin: 0 !important;
  border: none !important;
}

::-webkit-scrollbar {
  width: 7px;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #202437;
  width: 7px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #3B435E;
  width: 7px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #3B435E;
  width: 7px;
}

.requestActionPopup {
  direction: ltr;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/TeleDriversSection/styles.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,kBAAA;EACA,cAAA;AACJ;AACI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;EACA,oBAAA;AACR;AAEI;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,8BAAA;AAAR;AAEQ;EACI,kBAAA;EACA,eAAA;AAAZ;AAGQ;EACI,gBAAA;AADZ;AAKY;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAHhB;AAMY;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;AAJhB;AAMgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAJpB;AAOgB;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AALpB;AAQgB;EACI,mBAAA;AANpB;AASgB;EACI,mBAAA;AAPpB;AAUgB;EACI,mBAAA;AARpB;AAWgB;EACI,WAAA;EACA,aAAA;EACA,+CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AATpB;AAeY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAbhB;;AAmBA;EACI,oBAAA;EACA,uBAAA;AAhBJ;;AAmBA;EACI,UAAA;EACA,mBAAA;AAhBJ;;AAmBA;EACI,mBAAA;EACA,UAAA;EACA,mBAAA;AAhBJ;;AAmBA;EACI,mBAAA;EACA,UAAA;EACA,mBAAA;AAhBJ;;AAmBA;EACI,mBAAA;EACA,UAAA;AAhBJ;;AAmBA;EACI,cAAA;AAhBJ","sourcesContent":[".teleDriversSection {\r\n    height: calc(100vh - 556px);\r\n    overflow-x: hidden;\r\n    direction: rtl;\r\n\r\n    .teleDriverCount {\r\n        direction: ltr;\r\n        font-size: 14px;\r\n        line-height: 21px;\r\n        font-weight: 500;\r\n        font-family: 'Poppins';\r\n        color: rgba(255, 255, 255, 0.7);\r\n        margin-left: 13.84px;\r\n    }\r\n\r\n    .teleDriver {\r\n        height: 51px;\r\n        background: #2B3045;\r\n        margin-top: 16px;\r\n        border-radius: 10px;\r\n        padding: 16px 8px 16px 8px;\r\n        direction: ltr;\r\n        display: flex;\r\n        align-items: center;\r\n        position: relative;\r\n        gap: 12px;\r\n        margin-left: 13.84px;\r\n        min-width: 425px;\r\n        justify-content: space-between;\r\n\r\n        .teleDriverOption {\r\n            position: relative;\r\n            min-width: 24px;\r\n        }\r\n\r\n        .teleDriverOption:hover {\r\n            background: none;\r\n        }\r\n\r\n        .teleDriverSec {\r\n            .teleDriverName {\r\n                font-size: 16px;\r\n                line-height: 16px;\r\n                font-family: 'Poppins';\r\n                font-weight: 500;\r\n                margin-bottom: 5px;\r\n            }\r\n\r\n            .teleDriverDetails {\r\n                font-size: 14px;\r\n                line-height: 22px;\r\n                font-family: 'Poppins';\r\n                font-weight: 400;\r\n                display: flex;\r\n                gap: 10px;\r\n\r\n                .wrapper {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    position: relative;\r\n                }\r\n\r\n                span {\r\n                    border-radius: 50%;\r\n                    height: 12px;\r\n                    width: 12px;\r\n                    display: block;\r\n                    float: left;\r\n                    margin-right: 5px;\r\n                }\r\n\r\n                .green {\r\n                    background: #58DA78;\r\n                }\r\n\r\n                .orange {\r\n                    background: #FF8B1E;\r\n                }\r\n\r\n                .purple {\r\n                    background: #797E98;\r\n                }\r\n\r\n                .MuiBox-root:after {\r\n                    content: \"\";\r\n                    margin: 0 4px;\r\n                    border-left: 2px solid rgba(255, 255, 255, 0.2);\r\n                    position: absolute;\r\n                    bottom: 5px;\r\n                    right: -10px;\r\n                    height: 12.78px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .teleDriverImage {\r\n            img {\r\n                width: 51px;\r\n                height: 51px;\r\n                border-radius: 50%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.teleDriverDetails .MuiBox-root:last-child:after {\r\n    margin: 0 !important;\r\n    border: none !important;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 7px;\r\n    border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background: #202437;\r\n    width: 7px;\r\n    border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background: #3B435E;\r\n    width: 7px;\r\n    border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n    background: #3B435E;\r\n    width: 7px;\r\n}\r\n\r\n.requestActionPopup {\r\n    direction: ltr;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
